import { render } from "./FullscreenComparison.vue?vue&type=template&id=f186b808&scoped=true"
import script from "./FullscreenComparison.vue?vue&type=script&lang=js"
export * from "./FullscreenComparison.vue?vue&type=script&lang=js"

import "./FullscreenComparison.vue?vue&type=style&index=0&id=f186b808&scoped=true&lang=scss"

import exportComponent from "J:\\20_Mitarbeiter\\Christian\\240626_Logo_Europa_Babylon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f186b808"]])

export default __exports__